import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GanttColumn, GanttRow } from './models/headers-type.model';
import { id } from '@swimlane/ngx-charts';
import moment, { Moment } from 'moment';

@Component({
  selector: 'app-gantt',
  templateUrl: './gantt.component.html',
  styleUrl: './gantt.component.css'
})
export class GanttComponent {
  private yearStart = new Date(new Date().getFullYear(), 0, 1);
  private yearDays  = 365;
  adicionales = [];
  public meses = [];

  @Input() headers: GanttColumn[] = [
    {key:'funcionalidades', label: '', icono: 'circle_add', tooltip: 'Crear plan'},
    {key:'nombre', label: 'Plan / Actividades', sortable: true},
    {key:'responsable', label: 'Responsable', sortable: true},
    {key:'inicio', label: 'Inicio', sortable: true},
    {key:'dias', label: 'Días', sortable: true},
    {key:'fin', label: 'Fin', sortable: true},
    {key:'progreso', label: 'Progreso'},
    {key:'add', label: '', icono: 'circle_add', tooltip: 'Crear adicional'},
    {key:'adicionales', label: ''},
  ];
  @Input() year: number = moment().year();
  @Input() data: GanttRow[] = [];

  @Output() eventoBotonHeader = new EventEmitter;
  @Output() eventoBotonFuncionalidades = new EventEmitter;


  private head = '';
  private order = 'id'

  constructor(){}

  ngOnChanges(){
    this.meses = this.getMesesConDias(this.year);
    this.setYear(this.year);
    this.adicionales = this.data[0]?.series[0]?.adicionales ?? [];
  }

  clickEncabezado(encabezado: string){
    this.eventoBotonHeader.emit(encabezado);
  }
  clickTabla(encabezado: string, nivel: string, elemento?: GanttRow){
    this.eventoBotonFuncionalidades.emit({encabezado, nivel, elemento});
  }
  /**
   * Metodos de filtrado
   */
  iconoFiltro(encabezado: string, ){
    if(this.head === ''){
      return this.order;
    }

    if(encabezado !== this.head){
      return 'nous';
    }
    
    return this.order;
  }
  cambioFiltro(encabezado: string){
    if(this.iconoFiltro(encabezado) === 'nous'){
      return;
    }
    switch(this.order){
      case 'id':
        this.order = 'asc';
        this.head = encabezado;
        break;
      case 'asc':
        this.order = 'des';
        break;
      case 'des':
        this.order = 'id';
        this.head = '';
        break;
    }
    if (this.head !== '') {
      this.ordenarData();
    } else {
      // Aquí puedes restaurar el orden original si lo necesitas.
    }
  }
  ordenarData(){
    const campo = this.head;
    const factor = this.order === 'asc' ? 1 : -1;

    this.data = [...this.data].sort((a, b) => {
      const valorA = a[campo];
      const valorB = b[campo];

      if (valorA == null) return valorB == null ? 0 : 1;
      if (valorB == null) return -1;

      if (campo === 'inicio' || campo === 'fin') {
        return (
          valorA.valueOf() - valorB.valueOf()
        ) * factor;
      }

      if (
        typeof valorA === 'number' &&
        typeof valorB === 'number'
      ) {
        return (valorA - valorB) * factor;
      }

      return String(valorA).localeCompare(
        String(valorB),
        'es',
        { numeric: true, sensitivity: 'base' }
      ) * factor;
    });
  }

  /**
   * 
   */

  escrituraDate(date: Moment){
    return date?.format('YYYY-MM-DD') ?? ''
  }
  vizualizarActividad(endDate: Moment, startDate: Moment){
    const inicioAnio = moment(`${this.year}/01/01`);
    const finAnio = moment(`${this.year}/01/01`).endOf('year');
    return endDate.isAfter(inicioAnio) && startDate.isBefore(finAnio);
  }
  vizualizarProyecto(endDate: Moment, startDate: Moment){
    if(!endDate && !startDate) return true;
    const inicioAnio = moment(`${this.year}/01/01`);
    const finAnio = moment(`${this.year}/01/01`).endOf('year');
    return endDate.isAfter(inicioAnio) && startDate.isBefore(finAnio);
  }
  /** Variables para el gantt */
  
  setYear(year: number): void {
    this.yearStart = new Date(year, 0, 1);
    const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    this.yearDays  = isLeap ? 366 : 365;
  }

  getBarLeft(fecha: moment.Moment): string {
    if (!fecha) return '0%';
    const start = fecha.toDate();
    const days = (start.getTime() - this.yearStart.getTime()) / 86400000;
    return Math.max(0, (days / this.yearDays) * 100).toFixed(2) + '%';
  }

  getBarWidth(fechaIni: moment.Moment, fechaFin: moment.Moment): string {
    if (!fechaIni || !fechaFin) return '0%';
    const inicioAnio = moment(`${this.year}/01/01`);
    if(fechaIni.isBefore(inicioAnio)){
      fechaIni = inicioAnio;
    }
    const start = fechaIni.toDate();
    const end   = fechaFin.toDate();
    const days  = (end.getTime() - start.getTime()) / 86400000 + 1;
    return Math.max(0.5, (days / this.yearDays) * 100).toFixed(2) + '%';
  }

  getMesWidth(mes: any): string {
    return ((mes.value / this.yearDays) * 100).toFixed(3) + '%';
  }

  getMesesConDias(year: number) {
    return [
      { name: 'ene', value: 31 },
      { name: 'feb', value: new Date(year, 2, 0).getDate() }, // 28 o 29 según año bisiesto
      { name: 'mar', value: 31 },
      { name: 'abr', value: 30 },
      { name: 'may', value: 31 },
      { name: 'jun', value: 30 },
      { name: 'jul', value: 31 },
      { name: 'ago', value: 31 },
      { name: 'sep', value: 30 },
      { name: 'oct', value: 31 },
      { name: 'nov', value: 30 },
      { name: 'dic', value: 31 },
    ];
  }

  excelExport(){

  }
}